import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { IAppState } from 'types/app';
import SmallCardContainer from './SmallCardContainer';
import SmallCountAndTimer from './SmallCountAndTimer';
import SmallDeck from './SmallDeck';

type Props = ReturnType<typeof mapStateToProps>;

function SmallCards(props: Props) {
  const { displayCards, handSize } = props;

  return (
    <Fragment>
      <div className="opportunity-cards--small">
        <div className="opportunity-cards__left--small">
          <SmallDeck />
        </div>
        <div className="media__body opportunity-cards__body--small">
          <h2 className="media__heading heading heading--3">
            Opportunity deck
          </h2>
          <SmallCountAndTimer />
        </div>
      </div>
      <h2 className="heading heading--3 small-cards__heading">
        Pick a card from your hand (
        {displayCards.length}
        /
        {handSize}
        )
      </h2>
      <div className="hand hand--small-media">
        {displayCards.map(card => (
          <SmallCardContainer
            key={card.eventId}
            data={card}
          />
        ))}
      </div>
    </Fragment>
  );
}

SmallCards.displayName = 'SmallCards';

const mapStateToProps = ({
  cards: {
    cardsCount,
    deckSize,
    displayCards,
    handSize,
    isFetching,
  },
}: IAppState) => ({
  cardsCount,
  deckSize,
  displayCards,
  handSize,
  isFetching,
});

export default connect(mapStateToProps)(SmallCards);